import React from 'react'

import styles from './styles.module.css'

const Underlay = ({
  onClick = () => {},
  className = '',
  isVisible = false,
  criticalJs = false,
  action = '',
  controller = 'postcode-form'
}: {
  onClick?: () => void
  className?: string
  isVisible?: boolean
  criticalJs?: boolean
  action?: string
  controller?: string
}) => {
  if (criticalJs)
    return (
      <>
        <div
          className={`dropdown-underlay ${styles.stimulusUnderlay} ${styles.stimulusUnderlayTransparentStyles}`}
          data-action={`click->${controller}#${action}`}
        />
        <div
          className={`dropdown-underlay ${styles.stimulusUnderlay} ${styles.stimulusUnderlayShadedStyles}`}
          data-action={`click->${controller}#${action}`}
        />
      </>
    )

  return (
    <div
      className={`${styles.reactUnderlay} ${className}`}
      data-visible={isVisible}
      onClick={onClick}
      onKeyUp={onClick}
      role='button'
      tabIndex={-1}
    />
  )
}

export default Underlay
